import React, {type ReactNode} from 'react'
import {router} from "@inertiajs/react";

interface ButtonProps {
    tag?: 'a' | 'button'
    href?: string
    children: ReactNode
    className?: string
    theme?: 'primary' | 'secondary' | 'text' | 'danger'
    onClick?: (click: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
    nativeType?: 'button' | 'submit' | 'reset'
    disabled?: null | boolean
    loading?: null | boolean
    loadingText?: null | string
    testId?: string
    icon?: ReactNode
    'aria-label'?: string
    'aria-pressed'?: boolean
}

export default function GeneralButton(props: ButtonProps): ReactNode {
    const tag: string = typeof (props.tag) !== 'undefined' ? props.tag : 'button'

    const buttonClasses = (): string => {
        const classes: string[] = [
            'btn whitespace-nowrap flex flex-row space-x-2',
            props.theme !== undefined ? `btn-${props.theme}` : 'btn-primary',
        ]

        if (props.className) {
            classes.push(props.className)
        }

        if (tag === 'a' && (props.disabled === true)) {
            classes.push('disabled')
        }

        return classes.join(' ')
    }

    const loadingText = (): string => {
        return props.loadingText ?? 'Loading...'
    }

    const isDisabled = (): boolean => {
        return (props.disabled === true) || (props.loading === true)
    }

    if (tag === 'a') {
        return (
            <a href={props.href ?? '#'} className={buttonClasses()} data-testid={props.testId} aria-label={props['aria-label']}>
                {props.icon && <div className={'h-5 w-5'} aria-hidden="true">{props.icon}</div>}
                <div>{props.children}</div>
            </a>
        )
    }

    return (
        <button
            data-testid={props.testId}
            aria-label={props['aria-label']}
            aria-pressed={props['aria-pressed']}
            disabled={isDisabled()}
            className={buttonClasses()}
            onClick={(e) => {
                if (props.nativeType !== 'submit') {
                    e.preventDefault()
                }

                if (props.onClick !== undefined) {
                    props.onClick(e)
                }

                if (props.href) {
                    router.visit(props.href)
                }
            }}
            type={props.nativeType ?? 'button'}
        >
            {props.icon && <div className={'h-5 w-5'} aria-hidden="true">{props.icon}</div>}
            <div>
                {(props.loading === true) ? loadingText() : props.children}
            </div>
        </button>
    )
}
